import { useMediaQuery } from "@mui/material";

export const useIsMobile = () => {
    const mobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
    return mobile
}